// extracted by mini-css-extract-plugin
module.exports = {"div1":"SideDiv1_div1__20zuM","flex":"SideDiv1_flex__3hWYG","input":"SideDiv1_input__XhkfB","btn":"SideDiv1_btn__2YIeN","btn1":"SideDiv1_btn1__3Rb5H","btn2":"SideDiv1_btn2___e0PG"};